export default "__VITE_ASSET__D9wsVIC___"